import { ProductType, ResultType, selectResultType } from "features/searchResultsFacets";
import { store$ } from "@redux/store";
import { distinctUntilChanged, map } from "rxjs";
import { routingSelectors, buildNewUrl } from "features/routing";
import fastdom from "fastdom";
import ResultTab from "./resultTab";
import UrlSubdirectoryTypes from "../../enums/urlSubdirectoryTypes";

const { urlComponentsSelector } = routingSelectors;

export default class ManufacturedHomesTab extends ResultTab {
  constructor() {
    super();
    this.qaAttribute = 'manufactured-homes-tab';
    this.subdirectory = UrlSubdirectoryTypes.ManufacturedHomes.toString();
    this.content = 'Manufactured Homes';
    this.resultType = ResultType.Homes.toString();
    this.productType = ProductType.Manufactured.toString();

    const resultTypeChange$ = store$.pipe(
      map(selectResultType),
      map((resultType) => this.resultType === resultType),
      distinctUntilChanged(),
    );
    resultTypeChange$.subscribe(this.setIsActive.bind(this));

    const urlSegmentsChange$ = store$.pipe(
      map(urlComponentsSelector),
        distinctUntilChanged()
    );

    urlSegmentsChange$.subscribe(this.updateUrlSegments.bind(this));
  }

  updateUrlSegments(componentsUrl) {
    const { urlCoordinatesQueryString, urlLocation, urlQueryString, urlBuilderName } = componentsUrl;

    const urlConfiguration = {
      urlSubdirectory: this.subdirectory,
      urlCoordinatesQueryString,
      urlLocation,
      urlQueryString,
      urlBuilderName,
    }

    this.url = buildNewUrl(urlConfiguration);
    this.updateUrl(this.url);
    fastdom.mutate(() => {
      const tabElement = this.getNode();
      if (tabElement) {
        tabElement.href = this.url;
      }
    })
  }
}
